import React, { useState } from "react";
import Style from "../style/productratingform.module.scss";

const ProductRatingForm = () => {
  const [rating, setRating] = useState<number>(0);
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [comment, setComment] = useState<string>("");
  const [error, setError] = useState<string>("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!rating || !name || !email || !comment) {
      setError("Please fill in all fields");
      return;
    }
    console.log({
      rating,
      name,
      email,
      comment,
    });
    setRating(0);
    setName("");
    setEmail("");
    setComment("");
  };

  return (
    <div className={Style.formContainer}>
      <h2 className={Style.formTitle}>Leave a Review</h2>
      <form onSubmit={handleSubmit}>
        <div className={Style.formGroup}>
          <label className={Style.label} htmlFor="name">
            Your Name
          </label>
          <input
            type="text"
            id="name"
            className={Style.inputField}
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div className={Style.formGroup}>
          <label className={Style.label} htmlFor="email">
            Your Email
          </label>
          <input
            type="email"
            id="email"
            className={Style.inputField}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className={Style.formGroup}>
          <label className={Style.label} htmlFor="rating">
            Rating
          </label>
          <select
            id="rating"
            className={Style.inputField}
            value={rating}
            onChange={(e) => setRating(Number(e.target.value))}
            required
          >
            <option value={0} disabled>
              Select Rating
            </option>
            <option value={1}>1 - Poor</option>
            <option value={2}>2 - Fair</option>
            <option value={3}>3 - Good</option>
            <option value={4}>4 - Very Good</option>
            <option value={5}>5 - Excellent</option>
          </select>
        </div>

        <div className={Style.formGroup}>
          <label className={Style.label} htmlFor="comment">
            Your Review
          </label>
          <textarea
            id="comment"
            className={Style.textareaField}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            required
          />
        </div>

        {error && <p className={Style.error}>{error}</p>}

        <button type="submit" className={Style.submitButton}>
          Submit Review
        </button>
      </form>
    </div>
  );
};

export default ProductRatingForm;
